import gql from 'graphql-tag'

/** Legacy GraphQL query still used by /play/[state]/[city] flag-off SSR. */
export const QUERY_CITY_SEARCH = gql`
query cityCourses($stateName: String!, $city: String!) {
  cityCourses(state_name: $stateName, city: $city ) {
    name,
    facility_name,
    city,
    state,
    zip,
    address1,
    address2,
    facility_id
    photo_facility
  }
}
`
